import React, { useState, useRef, useEffect } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import "./Navbar.css";
import logo from '../../assests/salestology-img01.webp'

const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isServicesOpen, setIsServicesOpen] = useState(false);
    const [currentPath, setCurrentPath] = useState('/');
    const [activeSection, setActiveSection] = useState(''); 
    
    const servicesRef = useRef(null);
    const mobileServicesRef = useRef(null);
    
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const updateCurrentPath = () => {
            setCurrentPath(window.location.pathname);
        };
        updateCurrentPath();
        window.addEventListener('popstate', updateCurrentPath);
        return () => {
            window.removeEventListener('popstate', updateCurrentPath);
        };
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (location.pathname === '/') {
                const whoWeAreSection = document.getElementById('who-we-are-section');
                const whatWeOfferSection = document.getElementById('what-we-offer-section');
                const contactSection = document.getElementById('contact-section');
                
                const scrollPosition = window.scrollY + 100;
                
                if (whoWeAreSection && whatWeOfferSection && contactSection) {
                    const whoWeAreTop = whoWeAreSection.offsetTop;
                    const whatWeOfferTop = whatWeOfferSection.offsetTop;
                    const contactTop = contactSection.offsetTop;
                    
                    if (scrollPosition >= whoWeAreTop && scrollPosition < whatWeOfferTop) {
                        setActiveSection('about');
                    } else if (scrollPosition >= whatWeOfferTop && scrollPosition < contactTop) {
                        setActiveSection('services');
                    } else if (scrollPosition >= contactTop) {
                        setActiveSection('contact');
                    } else {
                        setActiveSection('');
                    }
                } else if (whoWeAreSection && whatWeOfferSection) {
                    const whoWeAreTop = whoWeAreSection.offsetTop;
                    const whatWeOfferTop = whatWeOfferSection.offsetTop;
                    
                    if (scrollPosition >= whoWeAreTop && scrollPosition < whatWeOfferTop) {
                        setActiveSection('about');
                    } else if (scrollPosition >= whatWeOfferTop) {
                        setActiveSection('services');
                    } else {
                        setActiveSection('');
                    }
                } else if (whoWeAreSection) {
                    const whoWeAreTop = whoWeAreSection.offsetTop;
                    
                    if (scrollPosition >= whoWeAreTop) {
                        setActiveSection('about');
                    } else {
                        setActiveSection('');
                    }
                }
            } else {
                setActiveSection('');
            }
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();
        
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [location.pathname]);

    const isLinkActive = (path) => {
        if (path === '/') {
            return currentPath === '/' && activeSection === '';
        }
        return currentPath.startsWith(path);
    };

    const isAboutActive = () => {
        return currentPath === '/' && activeSection === 'about';
    };

    const isServicesActive = () => {
        return currentPath.startsWith('/services') || (currentPath === '/' && activeSection === 'services');
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const toggleServices = () => {
        setIsServicesOpen(!isServicesOpen);
    };

    const scrollToWhoWeAre = (e) => {
        e.preventDefault();
        
        if (isMenuOpen) {
            setIsMenuOpen(false);
        }
        
        if (location.pathname !== '/') {
            navigate('/', { replace: true });
            setTimeout(() => {
                const element = document.getElementById('who-we-are-section');
                if (element) {
                    const elementPosition = element.offsetTop - 80;
                    window.scrollTo({
                        top: elementPosition,
                        behavior: 'smooth'
                    });
                } else {
                    const alternatives = [
                        document.querySelector('[id*="who-we-are"]'),
                        document.querySelector('[class*="who-we-are"]'),
                        document.querySelector('section[id*="about"]'),
                        document.querySelector('[id*="about"]')
                    ];
                    
                    for (const alt of alternatives) {
                        if (alt) {
                            const elementPosition = alt.offsetTop - 80;
                            window.scrollTo({
                                top: elementPosition,
                                behavior: 'smooth'
                            });
                            break;
                        }
                    }
                }
            }, 100);
        } else {
            setTimeout(() => {
                const element = document.getElementById('who-we-are-section');
                if (element) {
                    const elementPosition = element.offsetTop - 80;
                    window.scrollTo({
                        top: elementPosition,
                        behavior: 'smooth'
                    });
                } else {
                    const alternatives = [
                        document.querySelector('[id*="who-we-are"]'),
                        document.querySelector('[class*="who-we-are"]'),
                        document.querySelector('section[id*="about"]'),
                        document.querySelector('[id*="about"]')
                    ];
                    
                    for (const alt of alternatives) {
                        if (alt) {
                            const elementPosition = alt.offsetTop - 80;
                            window.scrollTo({
                                top: elementPosition,
                                behavior: 'smooth'
                            });
                            break;
                        }
                    }
                }
            }, isMenuOpen ? 300 : 0);
        }
    };

    const scrollToContact = (e) => {
        e.preventDefault();
        
        if (isMenuOpen) {
            setIsMenuOpen(false);
        }
        
        if (location.pathname !== '/') {
            navigate('/', { replace: true });
            setTimeout(() => {
                const element = document.getElementById('contact-section');
                if (element) {
                    const navbarHeight = 80;
                    const elementPosition = element.offsetTop - navbarHeight;
                    
                    window.scrollTo({
                        top: elementPosition,
                        behavior: 'smooth'
                    });
                } else {
                    const alternatives = [
                        document.querySelector('[id*="contact"]'),
                        document.querySelector('[class*="contact"]'),
                        document.querySelector('footer'),
                        document.querySelector('[id*="footer"]')
                    ];
                    
                    for (const alt of alternatives) {
                        if (alt) {
                            const navbarHeight = 80;
                            const elementPosition = alt.offsetTop - navbarHeight;
                            
                            window.scrollTo({
                                top: elementPosition,
                                behavior: 'smooth'
                            });
                            break;
                        }
                    }
                }
            }, 100);
        } else {
            setTimeout(() => {
                const element = document.getElementById('contact-section');
                if (element) {
                    const navbarHeight = 80;
                    const elementPosition = element.offsetTop - navbarHeight;
                    
                    window.scrollTo({
                        top: elementPosition,
                        behavior: 'smooth'
                    });
                } else {
                    const alternatives = [
                        document.querySelector('[id*="contact"]'),
                        document.querySelector('[class*="contact"]'),
                        document.querySelector('footer'),
                        document.querySelector('[id*="footer"]')
                    ];
                    
                    for (const alt of alternatives) {
                        if (alt) {
                            const navbarHeight = 80;
                            const elementPosition = alt.offsetTop - navbarHeight;
                            
                            window.scrollTo({
                                top: elementPosition,
                                behavior: 'smooth'
                            });
                            break;
                        }
                    }
                }
            }, isMenuOpen ? 300 : 0);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (servicesRef.current && !servicesRef.current.contains(event.target)) {
                if (mobileServicesRef.current && !mobileServicesRef.current.contains(event.target)) {
                    setIsServicesOpen(false);
                }
            }
        };

        if (isServicesOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isServicesOpen]);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 768 && isMenuOpen) {
                setIsMenuOpen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [isMenuOpen]);

    useEffect(() => {
        if (isMenuOpen) {
            const scrollY = window.scrollY;
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.left = '0';
            document.body.style.right = '0';
            document.body.style.overflow = 'hidden';
        } else {
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.left = '';
            document.body.style.right = '';
            document.body.style.overflow = '';
            if (scrollY) {
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
            }
        }

        return () => {
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.left = '';
            document.body.style.right = '';
            document.body.style.overflow = '';
        };
    }, [isMenuOpen]);

    return (
        <>
            <nav className="navbar">
                <div className="nav-container">
                    <a href="/" className="logo logo-wrapper">
                        <img
                            src={logo}
                            alt="SalesTology Logo"
                            className="logo-img"
                        />
                        <span className="trademark-icon">®</span>
                    </a>

                    <div className="nav-center">
                        <ul className="nav-links">
                            <li>
                                <a 
                                    href="/" 
                                    className={`nav-link ${isLinkActive('/') ? 'active' : ''}`}
                                >
                                    Home
                                </a>
                            </li>
                            <li>
                                <a 
                                    href="#who-we-are-section" 
                                    className={`nav-link ${isAboutActive() ? 'active' : ''}`}
                                    onClick={scrollToWhoWeAre}
                                >
                                    About Us
                                </a>
                            </li>
                            <li className="services-dropdown" ref={servicesRef}>
                                <button 
                                    className={`services-btn ${isServicesActive() ? 'active' : ''}`} 
                                    onClick={toggleServices}
                                >
                                    Services <ChevronDown size={16} />
                                </button>
                                <div className={`dropdown-menu ${isServicesOpen ? 'open' : ''}`}>
                                    <a href="/services/change-management" className="dropdown-item">Change Management</a>
                                    <a href="/services/business-intelligence" className="dropdown-item">Business Intelligence</a>
                                    <a href="/services/sales-effectiveness" className="dropdown-item">Sales Effectiveness Consultancy</a>
                                </div>
                            </li>
                            <li>
                                <a 
                                    href="/survey" 
                                    className={`nav-link ${isLinkActive('/survey') ? 'active' : ''}`}
                                >
                                    Survey
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="nav-buttons">
                        <a href="#contact-section" className="btn btn-outline" onClick={scrollToContact}>Get in Touch</a>
                    </div>

                    <button className={`mobile-menu-btn ${isMenuOpen ? 'menu-open' : ''}`} onClick={toggleMenu}>
                         <Menu size={24} />
                    </button>
                </div>

                <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
                    <div className="mobile-menu-content">
                        <div className="mobile-menu-header">
                            <div className="logo logo-wrapper">
                                <img
                                    src={logo}
                                    alt="SalesTology Logo"
                                    className="logo-img"
                                />
                                <span className="trademark-icon">®</span>
                            </div>
                            <button onClick={toggleMenu}>
                                <X size={24} />
                            </button>
                        </div>

                        <ul className="mobile-nav-links">
                            <li>
                                <a 
                                    href="/" 
                                    className={`mobile-nav-link ${isLinkActive('/') ? 'active' : ''}`} 
                                    onClick={() => setIsMenuOpen(false)}
                                >
                                    Home
                                </a>
                            </li>
                            <li>
                                <a 
                                    href="#who-we-are-section" 
                                    className={`mobile-nav-link ${isAboutActive() ? 'active' : ''}`}
                                    onClick={scrollToWhoWeAre}
                                >
                                    About Us
                                </a>
                            </li>
                            <li className="mobile-services" ref={mobileServicesRef}>
                                <button 
                                    className={`mobile-services-btn ${isServicesActive() ? 'active' : ''}`} 
                                    onClick={toggleServices}
                                >
                                    Services <ChevronDown size={16} />
                                </button>
                                <div className={`mobile-dropdown ${isServicesOpen ? 'open' : ''}`}>
                                    <a href="/services/change-management" className="mobile-dropdown-item" onClick={() => setIsMenuOpen(false)}>Change Management</a>
                                    <a href="/services/business-intelligence" className="mobile-dropdown-item" onClick={() => setIsMenuOpen(false)}>Business Intelligence</a>
                                    <a href="/services/sales-effectiveness" className="mobile-dropdown-item" onClick={() => setIsMenuOpen(false)}>Sales Effectiveness Consultancy</a>
                                </div>
                            </li>
                            <li>
                                <a 
                                    href="/survey" 
                                    className={`mobile-nav-link ${isLinkActive('/survey') ? 'active' : ''}`} 
                                    onClick={() => setIsMenuOpen(false)}
                                >
                                    Survey
                                </a>
                            </li>
                        </ul>

                        <div className="mobile-buttons">
                            <a href="#contact-section" className="btn btn-outline" onClick={scrollToContact}>Get in Touch</a>
                        </div>
                    </div>
                </div>
            </nav>
        </>
    );
};

export default Navbar;